import cx from 'classnames';
import * as React from 'react';

import { Props as ButtonProps } from 'components/Button';

import './styles/Buttons.scss';

export type ButtonsAlign = 'left' | 'center' | 'right';
export type ButtonsAxis = 'x' | 'y';
export type ButtonsMargin = 'small' | 'medium' | 'large' | 'xxxxlarge';
export type ButtonsReset = 'none' | 'mobile---medium' | 'desktop---large';
export type ButtonsReverseOrder = 'none' | 'mobile---medium' | 'desktop---large';

type Props = {
  children: any; // XXX
  className?: string;
  /** Full-width `Button`s (`axis="x"` only) */
  full?: boolean;
  fullButtonIndex?: number;
  /** Segmented control */
  group?: boolean;
  /** Margin in between buttons (`axis="x"` only) */
  margin?: ButtonsMargin;
  /** Reverse order of `Button`s at breakpoint  */
  reverseOrder?: ButtonsReverseOrder;
  /** Push `Button`s apart (`axis="x"` only) */
  split?: boolean;
} & DefaultProps &
  ButtonProps;

type DefaultProps = {
  /** Horizontal alignment of `Button`s (`axis="x"` only) */
  align: ButtonsAlign;
  /** Horizontal or vertical orientation */
  axis: ButtonsAxis;
  /** Stack `Button`s at breakpoint (`axis="x"` only) */
  reset: ButtonsReset;
};

export default class Buttons extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    align: 'center',
    axis: 'x',
    reset: 'mobile---medium',
  };

  render() {
    const {
      align,
      axis,
      children,
      className,
      full,
      fullButtonIndex,
      group,
      margin,
      reset,
      reverseOrder,
      split,
      ...props
    } = this.props;

    const wrappedChildren = React.Children.map(children, function(child, index) {
      if (child == null) {
        return null;
      }

      const childWithProps = React.cloneElement(child as React.ReactElement, { ...props });

      return (
        <div
          key={index}
          className={cx('Buttons-item', index === fullButtonIndex && 'Buttons-item--full')}
          data-test="buttons-item">
          {childWithProps}
        </div>
      );
    });

    return (
      <div
        className={cx(
          'Buttons',
          axis && `Buttons--${axis}`,
          reset && axis === 'x' && `Buttons--reset--${reset}`,
          reverseOrder && `Buttons--reverseOrder--${reverseOrder}`,
          {
            'Buttons--left': align === 'left' && axis === 'x',
            'Buttons--right': align === 'right' && axis === 'x',
            'Buttons--marginSmall': margin === 'small' && axis === 'x',
            'Buttons--marginMedium': margin === 'medium' && axis === 'x',
            'Buttons--marginLarge': margin === 'large' && axis === 'x',
            'Buttons--marginXXXXLarge': margin === 'xxxxlarge' && axis === 'x',
            'Buttons--full': full,
            'Buttons--group': group,
            'Buttons--split': split && Array.isArray(children) && children.length > 1,
          },
          className
        )}>
        {wrappedChildren}
      </div>
    );
  }
}
